import React, { FC, memo, useCallback } from 'react'

import { ChevronDown, ChevronUp, Container, NewTagContainer, NewTagIcon, Text } from './header-styles'
import { FilterType } from '../types'
import { useTranslation } from '../../../../hooks/locale'

import { stopPropagation } from '../../../../utils/dom-utils'

interface Props {
    filterTitle: string
    filterType: FilterType
    isActive: boolean
    onToggle: () => void
}

const FilterHeader: FC<Props> = ({ filterType, filterTitle, isActive, onToggle }) => {
    const { t } = useTranslation()
    const handleFilterHeaderClick = useCallback(
        (e: React.MouseEvent) => {
            stopPropagation(e)
            onToggle()
        },
        [onToggle],
    )

    return (
        <Container onClick={handleFilterHeaderClick}>
            <Text>{filterTitle}</Text>
            {filterType === FilterType.CANCELLATION_POLICY && (
                <NewTagContainer>
                    {t('new')}
                    <NewTagIcon aria-label="new tag icon" />
                </NewTagContainer>
            )}
            {isActive ? <ChevronUp aria-label="chevron up icon" /> : <ChevronDown aria-label="chevron down icon" />}
        </Container>
    )
}

export default memo(FilterHeader)
